import { Fragment, type ReactNode } from 'react';
import styled from 'styled-components';
import { Flex, Box } from '../box';
import BlackLink from '../link/link-components/black-link';
import { UiLinkProps } from '../link/ui-link';
import Text from '../text';

const BreadcrumbList = styled(Flex)`
  list-style: none;
`;

export type BreadcrumbItem = {
  label: ReactNode;
  to?: UiLinkProps['to'];
};

export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  'aria-label'?: string;
  'data-testid'?: string;
  size?: UiLinkProps['size'];
};

export function Breadcrumbs({
  items,
  'aria-label': ariaLabel = 'Breadcrumb',
  'data-testid': dataTestId,
  size = 'xs',
}: BreadcrumbsProps) {
  return (
    <Flex componentClass={'nav'} aria-label={ariaLabel} data-testid={dataTestId} gap={'xxs'} alignItems={'baseline'}>
      <BreadcrumbList componentClass={'ol'} gap={'xxs'} alignItems={'baseline'} margin={'none'} padding={'none'}>
        {items.map((item, index) => (
          <Fragment key={index}>
            {index > 0 && (
              <Box componentClass={'li'} aria-hidden={true}>
                <Text size={size} variant={'gray600'}>
                  /
                </Text>
              </Box>
            )}
            <Box componentClass={'li'}>
              {item.to ? (
                <BlackLink to={item.to} size={size} weight={500}>
                  {item.label}
                </BlackLink>
              ) : (
                <Text size={size} weight={500} variant={'action'} aria-current={'page'}>
                  {item.label}
                </Text>
              )}
            </Box>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Flex>
  );
}
